const MAX_NAME_LENGTH = 80

export const deriveHtmlFileName = (html: string, date: Date): string => {
  const title = html.match(/<title[^>]*>([^<]*)<\/title>/i)?.[1] ?? ''
  const slug = title
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .slice(0, MAX_NAME_LENGTH)
    .replace(/^-+|-+$/g, '')

  return `${slug || `copa-report-${date.toISOString().slice(0, 10)}`}.html`
}
